export default class CreateTrainingResearchCtrl {

  constructor ($scope, $timeout, $mdDialog, $cookies, WorkPlanSrv, WorkPlanModalSrv, $stateParams, WorkPlanIndicatorSrv, GlobalConfig) {
    var createTrainingVm = this
    const texts = GlobalConfig.appTexts
    const currentUser = JSON.parse($cookies.get('currentUser'))
    let post = {
      workplanId: currentUser.workplanId,
      teacherId: currentUser.teacherId
    }

    // VARIABLES
    createTrainingVm.isEditing = ($stateParams.workplanTeacherActivityId) ? true : false
    createTrainingVm.rangeType = GlobalConfig.periods.rangeType
    createTrainingVm.workplanTeacherActivityId = null
    createTrainingVm.createOrEdit = 'Crear'
    createTrainingVm.textCreateOrEdit = texts.saved
    createTrainingVm.createOrEditMV = texts.createDialog
    createTrainingVm.typePeriod = []
    createTrainingVm.periodsArray = []
    createTrainingVm.selectedTypePeriod = {}
    createTrainingVm.isTouchedPeriods = false
    createTrainingVm.startDate = null
    createTrainingVm.endDate = null
    createTrainingVm.notActive = GlobalConfig.generals.notActive
    createTrainingVm.notification = createTrainingVm.notActive
    createTrainingVm.minStartDate = moment().toDate()
    createTrainingVm.minEndDate = new Date()
    createTrainingVm.studentType = []
    createTrainingVm.studentNumber = []
    createTrainingVm.isSaveButtonDisabled = false
    createTrainingVm.amountOfStudentsRequired = false
    createTrainingVm.isFeedback = currentUser.isFeedback
    createTrainingVm.dt_start = $cookies.get('wp_start')
    createTrainingVm.dt_end = $cookies.get('wp_end')

    // METHODS
    createTrainingVm.hasError = hasError
    createTrainingVm.showErrorMessages = showErrorMessages
    createTrainingVm.addTraining = addTraining
    createTrainingVm.validateForm = validateForm
    createTrainingVm.validateCheklistPeriods = validateCheklistPeriods
    createTrainingVm.funSelectedPeriod = funSelectedPeriod
    createTrainingVm.startDateChange = startDateChange
    createTrainingVm.confirmTrainingAction = confirmTrainingAction
    createTrainingVm.addOrEditTraining = addOrEditTraining
    createTrainingVm.close = close
    createTrainingVm.cleanRangeType = cleanRangeType
    createTrainingVm.onActivityTypeChanged = onActivityTypeChanged
    createTrainingVm.checkStudents = () => {
      let inSeeder = GlobalConfig.minorActivityId.trainningResearchType === createTrainingVm.spaceType
      if (createTrainingVm.preg > 0 || createTrainingVm.postg > 0 || createTrainingVm.doct > 0) {
        createTrainingVm.amountOfStudentsRequired = false
      }
      if (inSeeder && !createTrainingVm.preg && !createTrainingVm.postg && !createTrainingVm.doct) {
        createTrainingVm.amountOfStudentsRequired = true
      }
    }

    createTrainingVm.updateRangeType = (val) => {
      createTrainingVm.rangeType = val
      createTrainingVm.periodsArray = []
      createTrainingVm.startDate = null
      createTrainingVm.endDate = null
    }
    createTrainingVm.updateRangeData = (val) => {
      createTrainingVm.periodsArray = val['periods']
      createTrainingVm.startDate = val['dates'][0]
      createTrainingVm.endDate = val['dates'][1]
    }

    activate()

    function activate () {
      if (createTrainingVm.isEditing) {
        createTrainingVm.workplanTeacherActivityId = $stateParams.workplanTeacherActivityId
        createTrainingVm.activityId = GlobalConfig.minorActivityId.training
        createTrainingVm.createOrEdit = 'Editar'
        createTrainingVm.createOrEditMV = texts.editDialog
        createTrainingVm.textCreateOrEdit = texts.modified
        getDataTrainings()
      }

      WorkPlanSrv.getListResearchTraining.getList(post).$promise
        .then(dataReturn => dataReturn.status ? loadData(dataReturn) : console.log('Comunications problem'))
    }

    function loadData (training) {
      createTrainingVm.listSpaceType = training.listSpacesTraining.items
      createTrainingVm.typePeriod = training.listPeriods.fulfillmentValue
    }

    function hasError (input) {
      if (input.$invalid && (input.$dirty || input.$touched)) {
        return 'has-error'
      }
    }

    function showErrorMessages (input) {
      return input.$dirty || input.$touched
    }

    function addTraining (isExecution) {
      let origin = GlobalConfig.activityTypeId.originActivityPlanning
      if (isExecution) {
        origin = GlobalConfig.activityTypeId.originActivityExecution
      }
      createJson(origin)
    }

    function validateForm (form) {
      return form.$invalid ||
             createTrainingVm.validateCheklistPeriods()
    }

    function validateCheklistPeriods () {
      return (createTrainingVm.rangeType == 1 ? createTrainingVm.periodsArray.length < 1 : false)
    }

    function funSelectedPeriod (period, checked) {
      if (checked) {
        if (!createTrainingVm.periodsArray.includes(period.periodId)) {
          createTrainingVm.periodsArray.push(period.periodId)
        }
      } else {
        let index = createTrainingVm.periodsArray.indexOf(period.periodId)
        if (index != -1) {
          createTrainingVm.periodsArray.splice(index, 1)
        }
      }
      createTrainingVm.isTouchedPeriods = true
    }

    function startDateChange () {
      let m = moment(createTrainingVm.startDate)
      createTrainingVm.minEndDate = m.isValid() ? m/*.add(1, 'days')*/.toDate() : null
    }

    function createJson (origin) {
      var training = {
        teacherId: post.teacherId,
        workplanId: post.workplanId,
        activityId: GlobalConfig.minorActivityId.training,
        name: createTrainingVm.title,
        description: createTrainingVm.description,
        results: createTrainingVm.results,
        hoursPlanning: createTrainingVm.plannedHours,
        link: createTrainingVm.link,
        isNotification: createTrainingVm.notification,
        spacesTrainingId: createTrainingVm.spaceType,
        timeRangeTypeId: createTrainingVm.rangeType,
        origin: origin,
        isFeedbackActivity: createTrainingVm.isFeedback
      }

      if (createTrainingVm.isEditing) { training.workplanTeacherActivityId = createTrainingVm.workplanTeacherActivityId }

      if (parseInt(createTrainingVm.rangeType) === GlobalConfig.periods.rangeType) {
        var arrayPeriod = []
        for (var index in createTrainingVm.periodsArray) {
          var temp = {
            periodId: createTrainingVm.periodsArray[index]
          }
          arrayPeriod.push(temp)
        }
        training.periods = arrayPeriod
      } else {
        training.startDate = createTrainingVm.startDate
        training.endDate = createTrainingVm.endDate
      }

      var arrayStudents = []

      if (createTrainingVm.preg) {
        var temp = {
          studentTypeId: GlobalConfig.trainingResearch.pregrado,
          number: createTrainingVm.preg
        }
        arrayStudents.push(temp)
      }

      if (createTrainingVm.postg) {
        var temp = {
          studentTypeId: GlobalConfig.trainingResearch.postgrado,
          number: createTrainingVm.postg
        }
        arrayStudents.push(temp)
      }

      if (createTrainingVm.doct) {
        var temp = {
          studentTypeId: GlobalConfig.trainingResearch.doctoral,
          number: createTrainingVm.doct
        }
        arrayStudents.push(temp)
      }

      if (arrayStudents.length > 0) {
        training.students = arrayStudents
      } else {
        training.students = null
      }
      addOrEditTraining(training)
    }

    function addOrEditTraining (training) {
      createTrainingVm.isSaveButtonDisabled = true
      WorkPlanSrv.addResearchTraining.save(training).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          confirmTrainingAction()
        } else {
          createTrainingVm.isSaveButtonDisabled = false
          console.log('Error Comunications')
        }
      }, function (data) {
        createTrainingVm.isSaveButtonDisabled = false
        console.log(data)
      })
    }

    function confirmTrainingAction (itemtraining) {
      let header = {
        createOrEdit: createTrainingVm.createOrEditMV,
        textCreateOrEdit: createTrainingVm.textCreateOrEdit,
        itemName: createTrainingVm.title,
        nameModal: texts.modalTypeName.trainingResearch,
        modalType: texts.modalTypeId.trainingResearch
      }
      WorkPlanModalSrv.setVariableSuccessDialog(header)
      WorkPlanModalSrv.successDialog(header).then((promise) => { })
    }

    function getDataTrainings () {
      let post = {
        workplanTeacherActivityId: parseInt(createTrainingVm.workplanTeacherActivityId),
        activityId: parseInt(createTrainingVm.activityId)
      }
      WorkPlanSrv.getResearchTrainingByActivityId.get(post).$promise.then(function (dataReturn) {
        if (dataReturn.status) {
          setValues(dataReturn.data)
        } else {
          console.log('Comunications problem with the server')
        }
      }, function (data) {

      })
    }

    function setValues (training) {
      createTrainingVm.title = training.nameResearch
      createTrainingVm.description = training.description
      createTrainingVm.results = training.resultsExpected
      createTrainingVm.plannedHours = training.hoursPlanning
      createTrainingVm.spaceType = training.itemTypeSpaceId
      createTrainingVm.link = training.link
      createTrainingVm.rangeType = training.timeRangeTypeId

      let m = moment(training.startDate, 'YYYY-MM-DD')
      createTrainingVm.dt_start = m.isValid() ? m.toDate() : null

      m = moment(training.endDate, 'YYYY-MM-DD')
      createTrainingVm.dt_end = m.isValid() ? m.toDate() : null

      if (training.isNotification == 1) {
        createTrainingVm.notification = true
      }

      if (createTrainingVm.rangeType == GlobalConfig.periods.rangeType) {
        var splits = training.periodId.split(',')
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createTrainingVm.periodsArray.push(parseInt(valor))
          createTrainingVm.selectedTypePeriod[valor] = true
        }
      }

      if (training.studentTypeId) {
        var splits = training.studentTypeId.split(',')
        var aux = training.studentNum.split(',')
        // var axu2 = aux
        for (var i = 0; i < splits.length; i++) {
          var valor = splits[i]
          createTrainingVm.studentType.push(parseInt(valor))
        }
        for (var i = 0; i < aux.length; i++) {
          var valor2 = aux[i]
          createTrainingVm.studentNumber.push(parseInt(valor2))
        }
      }

      for (var i = createTrainingVm.studentType.length - 1; i >= 0; i--) {
        if (createTrainingVm.studentType[i] == GlobalConfig.trainingResearch.pregrado) {
          createTrainingVm.preg = createTrainingVm.studentNumber[i]
        } else if (createTrainingVm.studentType[i] == GlobalConfig.trainingResearch.postgrado) {
          createTrainingVm.postg = createTrainingVm.studentNumber[i]
        } else if (createTrainingVm.studentType[i] == GlobalConfig.trainingResearch.doctoral) {
          createTrainingVm.doct = createTrainingVm.studentNumber[i]
        }
      }

      if (training.startDate) {
        var startDateNew = moment(training.startDate, 'YYYY-MM-DD').toDate()
        if (startDateNew <= moment().toDate()) {
          createTrainingVm.minStartDate = moment(training.startDate, 'YYYY-MM-DD').toDate()
        }
        startDateChange()
      }

      createTrainingVm.isEditing = true
      createTrainingVm.checkStudents()
    }

    function close () {
      return $mdDialog.hide()
    }

    function cleanRangeType () {
      if (parseInt(createTrainingVm.rangeType) == GlobalConfig.periods.rangeType) {
        createTrainingVm.startDate = null
        createTrainingVm.endDate = null
      } else {
        createTrainingVm.periodsArray = []
        createTrainingVm.selectedTypePeriod = null
      }
    }

    function onActivityTypeChanged (type) {
      if (type === GlobalConfig.minorActivityId.trainningResearchType) {
        createTrainingVm.amountOfStudentsRequired = true
      } else {
        createTrainingVm.amountOfStudentsRequired = false
      }
    }
  }// FIN DEL CONSTRUCTOR
  preventInput (event) {
    var vKey = 86
    if (event.keyCode == vKey) {
      event.preventDefault()
    }
    return
  }
}
CreateTrainingResearchCtrl.$inject = ['$scope', '$timeout', '$mdDialog', '$cookies', 'WorkPlanSrv', 'WorkPlanModalSrv', '$stateParams', 'WorkPlanIndicatorSrv', 'GlobalConfig']



// WEBPACK FOOTER //
// ./src/app/u-faculty/workplan/research/trainingResearch/createTrainingResearch/createTrainingResearchCtrl.js